<template>
  <v-row v-if="isMovil">
    <v-row class="py-12 mx-0 primary" align="center" justify="center">
      <v-col cols="12" sm="12" md="6" lg="5">
        <v-card elevation="8" class="rounded-lg" data-aos="fade-right">
          <v-card-title>
            <h3 class="primary--text mb-3">Déjanos un mensaje</h3>
            <p class="text-wrap font-weight-regular">
              <small>
                Nos encantaría escucharte, llena los datos y nos pondremos en
                contacto contigo.
              </small>
            </p>
          </v-card-title>
          <v-card-text class="d-flex justify-center align-center flex-column">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  name="nombre"
                  label="Nombre"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="Apellidos"
                  label="Apellidos"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="lastname"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="Correo electrónico"
                  label="Correo electrónico"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="Teléfono"
                  label="Teléfono"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="phone"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="cities"
                  label="Plantel*"
                  hide-details
                  outlined
                  v-model="campusSelected"
                  item-text="name"
                  item-value="id"
                >
                  <option @click="changeCity(campus)" :value="campus"></option>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="inscriptionOptions"
                  item-text="text"
                  item-value="item"
                  item-disabled="isDisabled"
                  text="isDisabled"
                  label="Oferta educativa de interés*"
                  hide-details
                  outlined
                  v-model="carrer"
                ></v-select>
              </v-col>
              <v-col cols="12" class="d-flex flex-column justify-end align-end">
                <vue-recaptcha
                  @expired="successRecaptcha = false"
                  @verify="reCAPTCHAcallback()"
                  sitekey="6Ldup2AkAAAAAKMM1piarFf0izdo1x_yhWCJOE3t"
                  :loadRecaptchaScript="true"
                ></vue-recaptcha>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="px-2 pb-4">
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  color="white"
                  large
                  block
                  rounded
                  class="button-vizcaya primary--text"
                  :disabled="loading || !successRecaptcha"
                  @click="sendMessage"
                >
                  Enviar mensaje
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
          {{ msg }}
          <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-row>
  <v-flex v-else style="width: 40vw">
    <v-card
      elevation="8"
      class="rounded-lg mx-6"
      data-aos="fade-right"
      style=""
    >
      <v-card-title>
        <h3 class="primary--text">Déjanos un mensaje</h3>
      </v-card-title>
      <v-card-text class="d-flex justify-center align-center flex-column">
        <v-row>
          <v-col cols="6">
            <v-text-field
              name="nombre"
              label="Nombre*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="Apellidos"
              label="Apellidos*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="lastname"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              name="Correo electrónico"
              label="Correo electrónico*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="email"
              required
              class="input"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="Teléfono"
              label="Teléfono*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="phone"
              required
              class="input"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              :items="cities"
              label="Plantel*"
              hide-details
              outlined
              v-model="campusSelected"
              item-text="name"
              item-value="id"
            >
              <option @click="changeCity(campus)" :value="campus"></option>
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-select
              :items="inscriptionOptions"
              item-text="text"
              item-value="item"
              item-disabled="isDisabled"
              text="isDisabled"
              label="Oferta educativa de interés*"
              hide-details
              outlined
              v-model="carrer"
            ></v-select>
          </v-col>
          <v-col cols="12" class="d-flex flex-column justify-end align-end">
            <vue-recaptcha
              @expired="successRecaptcha = false"
              @verify="reCAPTCHAcallback()"
              sitekey="6Ldup2AkAAAAAKMM1piarFf0izdo1x_yhWCJOE3t"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row class="px-2 pb-4">
          <v-col cols="12">
            <v-btn
              :loading="loading"
              color="white"
              large
              block
              rounded
              class="button-vizcaya primary--text"
              :disabled="loading || !successRecaptcha"
              @click="sendMessage"
            >
              Enviar mensaje
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
      {{ msg }}
      <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </v-flex>
</template>
<style scoped>
.text-wrap {
  word-break: break-word;
}
.input {
  height: 46px;
}
</style>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "Contacto",
  props: ["isMovil"],

  data: () => ({
    inscriptionOptions: [],
    campusSelected: "",
    windowHeight: 0,
    scrollY: 0,
    name: null,
    lastname: null,
    email: null,
    phone: null,
    state: null,
    carrer: null,
    birthday: new Date().toISOString().substr(0, 10),
    date: null,
    menu: false,
    snackbar: false,
    msg: "",
    color: "",
    loading: false,
    successRecaptcha: false,
    information: {
      name_first: "",
      last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
    },
  }),
  methods: {
    changeCity(key) {
      this.$store.dispatch("cities/setCity", key);
    },
    onScroll(e) {
      var inscriptionsWindow = document.getElementById("main");
      this.windowHeight = inscriptionsWindow.scrollHeight;
      this.scrollY = window.scrollY;
    },
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },
    sendMessage() {
      this.loading = true;
      if (
        this.name != null &&
        this.lastname != null &&
        this.email != null &&
        this.phone != null &&
        this.information.campus != null &&
        this.carrer != null
      ) {
        this.information.name_first = this.name;
        this.information.last_name = this.lastname;
        this.information.phone = this.phone;
        this.information.email = this.email;
        this.information.carrer = this.carrer;

        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("lastname", this.lastname);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("state", this.information.campus);
        formData.append("carrer", this.carrer);
        formData.append("birthday", "");
        axios({
          method: "post",
          url: "https://informesuva.tidingo.com/api/create-inscription",
          data: formData,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        }).then((response) => {
          if (response.data.status == "200") {
            this.msg = "Mensaje enviado, pronto estaremos en contacto contigo.";
            this.color = "success";
            this.snackbar = true;
            this.name = null;
            this.lastname = null;
            this.email = null;
            this.phone = null;
            this.information.campus = null;
            this.carrer = null;
            this.birthday = new Date().toISOString().substr(0, 10);
            this.$router.push("/gracias-informes");
          } else {
            this.msg = "Algo salio mal. Intentelo nuevamente";
            this.color = "error";
            this.snackbar = true;
          }
          this.loading = false;
        });
      } else {
        this.loading = false;
        this.msg = "Complete todos los datos";
        this.color = "warning";
        this.snackbar = true;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  mounted() {},
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.birthday);
    },
    ...mapState({
      city_selected: (state) => state.cities.city_selected,
      campus: (state) => state.cities.campus,
      cities: (state) => state.cities.cities,
    }),
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  watch: {
    campusSelected(val) {
      this.changeCity(val);
      let sendCity = _.find(this.cities, ["id", val]);
      this.information.campus = sendCity.name;
      var self = this;
      axios({
        method: "get",
        url:
          "https://adminuva.tidingo.com/api/data-colegio?link_campus=" +
          sendCity.link,
        config: {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          withCredentials: true,
          credentials: "same-origin",
        },
      })
        .then(function (response) {
          var offer = response.data.data.campus_selected;

          self.inscriptionOptions = [];
          if (offer.preescolar != null) {
            self.inscriptionOptions.push({
              text: "Preescolar",
              isDisabled: false,
            });
          }
          if (offer.primaria != null) {
            self.inscriptionOptions.push({
              text: "Primaria",
              isDisabled: false,
            });
          }
          if (offer.secundaria != null) {
            self.inscriptionOptions.push({
              text: "Secundaria",
              isDisabled: false,
            });
          }
          if (offer.preparatoria != null) {
            self.inscriptionOptions.push({
              text: "Preparatoria",
              isDisabled: false,
            });
          }
        })
        .catch(function (error) {});
    },
  },
};
</script>
